import { Modal } from "ui";

import { useDeleteCategory } from "../../../apis";
import { CategoryTypes } from "../../../constants/enums";
import { DeleteCategoryModalProps } from "./DeleteCategoryModal.types";

import styles from "./DeleteCategoryModal.module.scss";

const DeleteCategoryModal = ({
  isOpen,
  id,
  type,
  name,
  onClose,
  onDeleteSuccess
}: DeleteCategoryModalProps) => {
  const { isLoading: isLoadingDeleteCategory, mutate: mutateDeleteCategory } =
    useDeleteCategory({
      onSuccess: () => {
        onClose();
        onDeleteSuccess();
      }
    });

  const onDeleteCategory = () => {
    mutateDeleteCategory({ id });
  };

  const DELETE_CATEGORY_MESSAGES = {
    [CategoryTypes.MAIN_CATEGORY]: {
      title: "Delete Category",
      errorMessage: (
        <>
          Are you sure you want to delete the category <b>{name}</b>? This
          action will lead to deleting all the Sub-categories and
          Sub-sub-categories in this Category.
        </>
      )
    },
    [CategoryTypes.SUB_CATEGORY]: {
      title: "Delete Sub-Category",
      errorMessage: (
        <>
          Are you sure you want to delete the sub-category <b>{name}</b>? This
          action will lead to deleting all Sub-sub-categories in this
          Sub-Category.
        </>
      )
    },

    [CategoryTypes.SUB_CHILD_CATEGORY]: {
      title: "Delete Sub-sub-Category",
      errorMessage: (
        <>
          Are you sure you want to delete the sub-sub-category <b>{name}</b>?
        </>
      )
    }
  };

  const { title, errorMessage } = DELETE_CATEGORY_MESSAGES[type];

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title={title}
      isLoading={isLoadingDeleteCategory}
      className={styles["delete-category"]}
      okText="Delete"
      onOk={onDeleteCategory}
      onClose={onClose}
    >
      <p className={styles["delete-category__text"]}>{errorMessage}</p>
    </Modal>
  );
};

export default DeleteCategoryModal;
